module.exports = __webpack_public_path__ + "img/agg-icon.001d2c26.jpg";